/** This file was generated by graphql-codegen. All direct modifications will be overwritten. */
import { Injectable } from '@angular/core';
import * as ApolloCore from '@apollo/client/core';
import { gql, Apollo as ApolloClient } from 'apollo-angular';
import * as Apollo from 'apollo-angular';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
}

export interface AntivirusResultInput {
	message?: InputMaybe<Scalars['String']['input']>;
	status: AntivirusStatus;
}

export interface AntivirusState {
	__typename?: 'AntivirusState';
	finishedAt?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	status: AntivirusStatus;
}

export enum AntivirusStatus {
	CLEAN = 'CLEAN',
	ERROR = 'ERROR',
	INFECTED = 'INFECTED',
	PENDING = 'PENDING',
}

export interface File {
	__typename?: 'File';
	antivirusState?: Maybe<AntivirusState>;
	createdAt: Scalars['Int']['output'];
	editorStateId?: Maybe<Scalars['String']['output']>;
	filename: Scalars['String']['output'];
	infraVersion?: Maybe<Scalars['String']['output']>;
	itemId?: Maybe<Scalars['String']['output']>;
	key: Scalars['String']['output'];
	preflightOptions?: Maybe<PreflightOptions>;
	preflightState?: Maybe<PreflightState>;
	presignedPost?: Maybe<PresignedPost>;
	productId?: Maybe<Scalars['Int']['output']>;
	storeId: Scalars['Int']['output'];
	ttl: Scalars['Int']['output'];
	type: FileType;
}

export enum FileType {
	ASSET = 'ASSET',
	ATTACHMENT = 'ATTACHMENT',
	PRINTFILE = 'PRINTFILE',
}

export interface JobState {
	__typename?: 'JobState';
	finishedAt?: Maybe<Scalars['Int']['output']>;
	lastRetryAt?: Maybe<Scalars['Int']['output']>;
	processError?: Maybe<ProcessError>;
	queuedAt?: Maybe<Scalars['Int']['output']>;
	reference?: Maybe<Scalars['String']['output']>;
	retryCount?: Maybe<Scalars['Int']['output']>;
}

export interface LocaleString {
	__typename?: 'LocaleString';
	en?: Maybe<Scalars['String']['output']>;
	fi?: Maybe<Scalars['String']['output']>;
	sv?: Maybe<Scalars['String']['output']>;
}

export interface LocaleStringInput {
	en?: InputMaybe<Scalars['String']['input']>;
	fi?: InputMaybe<Scalars['String']['input']>;
	sv?: InputMaybe<Scalars['String']['input']>;
}

export interface Mutation {
	__typename?: 'Mutation';
	forceRetryPreflight?: Maybe<File>;
	retryPreflight?: Maybe<File>;
	updateAntivirusResult?: Maybe<File>;
	updateFileTTL?: Maybe<File>;
	updatePreflightProgress: ProgressUpdate;
	updatePreflightReport?: Maybe<File>;
	uploadFile?: Maybe<File>;
}

export interface MutationforceRetryPreflightArgs {
	key: Scalars['String']['input'];
}

export interface MutationretryPreflightArgs {
	key: Scalars['String']['input'];
}

export interface MutationupdateAntivirusResultArgs {
	input: AntivirusResultInput;
	key: Scalars['String']['input'];
}

export interface MutationupdateFileTTLArgs {
	key: Scalars['String']['input'];
	ttl: Scalars['Int']['input'];
}

export interface MutationupdatePreflightProgressArgs {
	key: Scalars['String']['input'];
	progress: Scalars['Int']['input'];
}

export interface MutationupdatePreflightReportArgs {
	input: PrintfileReportInput;
	key: Scalars['String']['input'];
}

export interface MutationuploadFileArgs {
	filename: Scalars['String']['input'];
	input: UploadFileInput;
}

export interface PreflightOptions {
	__typename?: 'PreflightOptions';
	color?: Maybe<Scalars['String']['output']>;
	errorResolution?: Maybe<Scalars['Int']['output']>;
	height?: Maybe<Scalars['Int']['output']>;
	precision?: Maybe<Scalars['Int']['output']>;
	profile?: Maybe<Scalars['String']['output']>;
	scope?: Maybe<Scalars['Int']['output']>;
	warningResolution?: Maybe<Scalars['Int']['output']>;
	width?: Maybe<Scalars['Int']['output']>;
}

export interface PreflightOptionsInput {
	color?: InputMaybe<Scalars['String']['input']>;
	errorResolution?: InputMaybe<Scalars['Int']['input']>;
	height?: InputMaybe<Scalars['Int']['input']>;
	precision?: InputMaybe<Scalars['Int']['input']>;
	profile: Scalars['String']['input'];
	scope?: InputMaybe<Scalars['Int']['input']>;
	warningResolution?: InputMaybe<Scalars['Int']['input']>;
	width?: InputMaybe<Scalars['Int']['input']>;
}

export interface PreflightState {
	__typename?: 'PreflightState';
	jobState?: Maybe<JobState>;
	report?: Maybe<PrintfileReport>;
}

export enum PreflightStatus {
	ERROR = 'ERROR',
	NOT_PRINTABLE = 'NOT_PRINTABLE',
	PENDING = 'PENDING',
	PRINTABLE = 'PRINTABLE',
}

export interface PresignedPost {
	__typename?: 'PresignedPost';
	fields: Array<Array<Scalars['String']['output']>>;
	url: Scalars['String']['output'];
}

export interface PrintfileReport {
	__typename?: 'PrintfileReport';
	bleed?: Maybe<Scalars['Float']['output']>;
	errorCount?: Maybe<Scalars['Int']['output']>;
	errors?: Maybe<Array<Maybe<PrintfileReportDetail>>>;
	pageHeight?: Maybe<Scalars['Float']['output']>;
	pageWidth?: Maybe<Scalars['Float']['output']>;
	status?: Maybe<PreflightStatus>;
	unit?: Maybe<Scalars['String']['output']>;
	warningCount?: Maybe<Scalars['Int']['output']>;
	warnings?: Maybe<Array<Maybe<PrintfileReportDetail>>>;
}

export interface PrintfileReportDetail {
	__typename?: 'PrintfileReportDetail';
	errorCode?: Maybe<Scalars['String']['output']>;
	internalMessage?: Maybe<LocaleString>;
	message?: Maybe<LocaleString>;
	occurrences?: Maybe<PrintfileReportDetailOccurrences>;
}

export interface PrintfileReportDetailInput {
	errorCode?: InputMaybe<Scalars['String']['input']>;
	internalMessage?: InputMaybe<LocaleStringInput>;
	message?: InputMaybe<LocaleStringInput>;
	occurrences?: InputMaybe<PrintfileReportDetailOccurrencesInput>;
}

export interface PrintfileReportDetailOccurrences {
	__typename?: 'PrintfileReportDetailOccurrences';
	amount?: Maybe<Scalars['Int']['output']>;
	pages?: Maybe<Scalars['String']['output']>;
}

export interface PrintfileReportDetailOccurrencesInput {
	amount?: InputMaybe<Scalars['Int']['input']>;
	pages?: InputMaybe<Scalars['String']['input']>;
}

export interface PrintfileReportInput {
	bleed?: InputMaybe<Scalars['Float']['input']>;
	errorCount?: InputMaybe<Scalars['Int']['input']>;
	errors?: InputMaybe<Array<InputMaybe<PrintfileReportDetailInput>>>;
	pageHeight?: InputMaybe<Scalars['Float']['input']>;
	pageWidth?: InputMaybe<Scalars['Float']['input']>;
	status: PreflightStatus;
	unit?: InputMaybe<Scalars['String']['input']>;
	warningCount?: InputMaybe<Scalars['Int']['input']>;
	warnings?: InputMaybe<Array<InputMaybe<PrintfileReportDetailInput>>>;
}

export interface ProcessError {
	__typename?: 'ProcessError';
	message: Scalars['String']['output'];
	timestamp: Scalars['Int']['output'];
}

export interface ProgressUpdate {
	__typename?: 'ProgressUpdate';
	key: Scalars['String']['output'];
	progress: Scalars['Int']['output'];
}

export interface Query {
	__typename?: 'Query';
	getFile?: Maybe<File>;
	getFiles: Array<File>;
}

export interface QuerygetFileArgs {
	key: Scalars['String']['input'];
}

export interface QuerygetFilesArgs {
	keys: Array<Scalars['String']['input']>;
}

export interface Subscription {
	__typename?: 'Subscription';
	onFileUpdate?: Maybe<File>;
	onPreflightProgress?: Maybe<ProgressUpdate>;
}

export interface SubscriptiononFileUpdateArgs {
	key?: InputMaybe<Scalars['String']['input']>;
}

export interface SubscriptiononPreflightProgressArgs {
	key?: InputMaybe<Scalars['String']['input']>;
}

export interface UploadAssetInput {
	storeId: Scalars['Int']['input'];
}

export interface UploadAttachmentInput {
	storeId: Scalars['Int']['input'];
}

export type UploadFileDataInput =
	| { asset: UploadAssetInput; attachment?: never; printfile?: never }
	| { asset?: never; attachment: UploadAttachmentInput; printfile?: never }
	| { asset?: never; attachment?: never; printfile: UploadPrintfileInput };

export interface UploadFileInput {
	data: UploadFileDataInput;
	type: FileType;
}

export interface UploadPrintfileInput {
	editorStateId?: InputMaybe<Scalars['String']['input']>;
	itemId?: InputMaybe<Scalars['String']['input']>;
	preflightOptions?: InputMaybe<PreflightOptionsInput>;
	productId: Scalars['Int']['input'];
	storeId: Scalars['Int']['input'];
}

export type FilePropsFragment_File_preflightOptions_PreflightOptions = {
	__typename?: 'PreflightOptions';
	profile?: string | null;
};

export type FilePropsFragment_File_antivirusState_AntivirusState = {
	__typename?: 'AntivirusState';
	status: AntivirusStatus;
};

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail_message_LocaleString =
	{ __typename?: 'LocaleString'; en?: string | null; fi?: string | null; sv?: string | null };

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail_internalMessage_LocaleString =
	{ __typename?: 'LocaleString'; en?: string | null; fi?: string | null; sv?: string | null };

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail_occurrences_PrintfileReportDetailOccurrences =
	{ __typename?: 'PrintfileReportDetailOccurrences'; amount?: number | null; pages?: string | null };

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail =
	{
		__typename?: 'PrintfileReportDetail';
		errorCode?: string | null;
		message?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail_message_LocaleString | null;
		internalMessage?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail_internalMessage_LocaleString | null;
		occurrences?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail_occurrences_PrintfileReportDetailOccurrences | null;
	};

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail_message_LocaleString =
	{ __typename?: 'LocaleString'; en?: string | null; fi?: string | null; sv?: string | null };

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail_internalMessage_LocaleString =
	{ __typename?: 'LocaleString'; en?: string | null; fi?: string | null; sv?: string | null };

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail_occurrences_PrintfileReportDetailOccurrences =
	{ __typename?: 'PrintfileReportDetailOccurrences'; amount?: number | null; pages?: string | null };

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail =
	{
		__typename?: 'PrintfileReportDetail';
		errorCode?: string | null;
		message?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail_message_LocaleString | null;
		internalMessage?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail_internalMessage_LocaleString | null;
		occurrences?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail_occurrences_PrintfileReportDetailOccurrences | null;
	};

export type FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport = {
	__typename?: 'PrintfileReport';
	status?: PreflightStatus | null;
	errorCount?: number | null;
	warningCount?: number | null;
	errors?: Array<FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_errors_PrintfileReportDetail | null> | null;
	warnings?: Array<FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport_warnings_PrintfileReportDetail | null> | null;
};

export type FilePropsFragment_File_preflightState_PreflightState_jobState_JobState_processError_ProcessError =
	{ __typename?: 'ProcessError'; message: string; timestamp: number };

export type FilePropsFragment_File_preflightState_PreflightState_jobState_JobState = {
	__typename?: 'JobState';
	queuedAt?: number | null;
	processError?: FilePropsFragment_File_preflightState_PreflightState_jobState_JobState_processError_ProcessError | null;
};

export type FilePropsFragment_File_preflightState_PreflightState = {
	__typename?: 'PreflightState';
	report?: FilePropsFragment_File_preflightState_PreflightState_report_PrintfileReport | null;
	jobState?: FilePropsFragment_File_preflightState_PreflightState_jobState_JobState | null;
};

export type FilePropsFragment = {
	__typename?: 'File';
	key: string;
	ttl: number;
	createdAt: number;
	preflightOptions?: FilePropsFragment_File_preflightOptions_PreflightOptions | null;
	antivirusState?: FilePropsFragment_File_antivirusState_AntivirusState | null;
	preflightState?: FilePropsFragment_File_preflightState_PreflightState | null;
};

export type getFileQuery_getFile_File = {
	__typename?: 'File';
	key: string;
	ttl: number;
	createdAt: number;
	preflightOptions?: FilePropsFragment_File_preflightOptions_PreflightOptions | null;
	antivirusState?: FilePropsFragment_File_antivirusState_AntivirusState | null;
	preflightState?: FilePropsFragment_File_preflightState_PreflightState | null;
};

export type getFileQuery_Query = { __typename?: 'Query'; getFile?: getFileQuery_getFile_File | null };

export type getFileQueryVariables = Exact<{
	key: Scalars['String']['input'];
}>;

export type getFileQuery = getFileQuery_Query;

export type onFileUpdateSubscription_onFileUpdate_File = {
	__typename?: 'File';
	key: string;
	ttl: number;
	createdAt: number;
	preflightOptions?: FilePropsFragment_File_preflightOptions_PreflightOptions | null;
	antivirusState?: FilePropsFragment_File_antivirusState_AntivirusState | null;
	preflightState?: FilePropsFragment_File_preflightState_PreflightState | null;
};

export type onFileUpdateSubscription_Subscription = {
	__typename?: 'Subscription';
	onFileUpdate?: onFileUpdateSubscription_onFileUpdate_File | null;
};

export type onFileUpdateSubscriptionVariables = Exact<{
	key: Scalars['String']['input'];
}>;

export type onFileUpdateSubscription = onFileUpdateSubscription_Subscription;

export type onPreflightProgressSubscription_onPreflightProgress_ProgressUpdate = {
	__typename?: 'ProgressUpdate';
	key: string;
	progress: number;
};

export type onPreflightProgressSubscription_Subscription = {
	__typename?: 'Subscription';
	onPreflightProgress?: onPreflightProgressSubscription_onPreflightProgress_ProgressUpdate | null;
};

export type onPreflightProgressSubscriptionVariables = Exact<{
	key: Scalars['String']['input'];
}>;

export type onPreflightProgressSubscription = onPreflightProgressSubscription_Subscription;

export type uploadFileMutation_uploadFile_File_presignedPost_PresignedPost = {
	__typename?: 'PresignedPost';
	url: string;
	fields: Array<Array<string>>;
};

export type uploadFileMutation_uploadFile_File = {
	__typename?: 'File';
	key: string;
	ttl: number;
	presignedPost?: uploadFileMutation_uploadFile_File_presignedPost_PresignedPost | null;
};

export type uploadFileMutation_Mutation = {
	__typename?: 'Mutation';
	uploadFile?: uploadFileMutation_uploadFile_File | null;
};

export type uploadFileMutationVariables = Exact<{
	filename: Scalars['String']['input'];
	input: UploadFileInput;
}>;

export type uploadFileMutation = uploadFileMutation_Mutation;

export type retryPreflightMutation_retryPreflight_File = {
	__typename?: 'File';
	key: string;
	ttl: number;
	createdAt: number;
	preflightOptions?: FilePropsFragment_File_preflightOptions_PreflightOptions | null;
	antivirusState?: FilePropsFragment_File_antivirusState_AntivirusState | null;
	preflightState?: FilePropsFragment_File_preflightState_PreflightState | null;
};

export type retryPreflightMutation_Mutation = {
	__typename?: 'Mutation';
	retryPreflight?: retryPreflightMutation_retryPreflight_File | null;
};

export type retryPreflightMutationVariables = Exact<{
	key: Scalars['String']['input'];
}>;

export type retryPreflightMutation = retryPreflightMutation_Mutation;

export const FilePropsFragmentDoc = gql`
	fragment FileProps on File {
		key
		ttl
		createdAt
		preflightOptions {
			profile
		}
		antivirusState {
			status
		}
		preflightState {
			report {
				status
				errorCount
				warningCount
				errors {
					errorCode
					message {
						en
						fi
						sv
					}
					internalMessage {
						en
						fi
						sv
					}
					occurrences {
						amount
						pages
					}
				}
				warnings {
					errorCode
					message {
						en
						fi
						sv
					}
					internalMessage {
						en
						fi
						sv
					}
					occurrences {
						amount
						pages
					}
				}
			}
			jobState {
				queuedAt
				processError {
					message
					timestamp
				}
			}
		}
	}
`;
export const getFileDocument = gql`
	query getFile($key: String!) {
		getFile(key: $key) {
			...FileProps
		}
	}
	${FilePropsFragmentDoc}
`;

@Injectable({
	providedIn: 'root',
})
export class getFileGQL extends Apollo.Query<getFileQuery, getFileQueryVariables> {
	document = getFileDocument;
	client = 'fileApiClient';
	constructor(apollo: ApolloClient) {
		super(apollo);
	}
}
export const onFileUpdateDocument = gql`
	subscription onFileUpdate($key: String!) {
		onFileUpdate(key: $key) {
			...FileProps
		}
	}
	${FilePropsFragmentDoc}
`;

@Injectable({
	providedIn: 'root',
})
export class onFileUpdateGQL extends Apollo.Subscription<
	onFileUpdateSubscription,
	onFileUpdateSubscriptionVariables
> {
	document = onFileUpdateDocument;
	client = 'fileApiClient';
	constructor(apollo: ApolloClient) {
		super(apollo);
	}
}
export const onPreflightProgressDocument = gql`
	subscription onPreflightProgress($key: String!) {
		onPreflightProgress(key: $key) {
			key
			progress
		}
	}
`;

@Injectable({
	providedIn: 'root',
})
export class onPreflightProgressGQL extends Apollo.Subscription<
	onPreflightProgressSubscription,
	onPreflightProgressSubscriptionVariables
> {
	document = onPreflightProgressDocument;
	client = 'fileApiClient';
	constructor(apollo: ApolloClient) {
		super(apollo);
	}
}
export const uploadFileDocument = gql`
	mutation uploadFile($filename: String!, $input: UploadFileInput!) {
		uploadFile(filename: $filename, input: $input) {
			key
			ttl
			presignedPost {
				url
				fields
			}
		}
	}
`;

@Injectable({
	providedIn: 'root',
})
export class uploadFileGQL extends Apollo.Mutation<uploadFileMutation, uploadFileMutationVariables> {
	document = uploadFileDocument;
	client = 'fileApiClient';
	constructor(apollo: ApolloClient) {
		super(apollo);
	}
}
export const retryPreflightDocument = gql`
	mutation retryPreflight($key: String!) {
		retryPreflight(key: $key) {
			...FileProps
		}
	}
	${FilePropsFragmentDoc}
`;

@Injectable({
	providedIn: 'root',
})
export class retryPreflightGQL extends Apollo.Mutation<
	retryPreflightMutation,
	retryPreflightMutationVariables
> {
	document = retryPreflightDocument;
	client = 'fileApiClient';
	constructor(apollo: ApolloClient) {
		super(apollo);
	}
}

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

interface WatchQueryOptionsAlone<V>
	extends Omit<ApolloCore.WatchQueryOptions<V>, 'query' | 'variables'> {}

interface QueryOptionsAlone<V> extends Omit<ApolloCore.QueryOptions<V>, 'query' | 'variables'> {}

interface MutationOptionsAlone<T, V>
	extends Omit<ApolloCore.MutationOptions<T, V>, 'mutation' | 'variables'> {}

interface SubscriptionOptionsAlone<V>
	extends Omit<ApolloCore.SubscriptionOptions<V>, 'query' | 'variables'> {}

@Injectable({ providedIn: 'root' })
export class FileApiService {
	constructor(
		private getFileGql: getFileGQL,
		private onFileUpdateGql: onFileUpdateGQL,
		private onPreflightProgressGql: onPreflightProgressGQL,
		private uploadFileGql: uploadFileGQL,
		private retryPreflightGql: retryPreflightGQL,
	) {}

	getFile(variables: getFileQueryVariables, options?: QueryOptionsAlone<getFileQueryVariables>) {
		return this.getFileGql.fetch(variables, options);
	}

	getFileWatch(
		variables: getFileQueryVariables,
		options?: WatchQueryOptionsAlone<getFileQueryVariables>,
	) {
		return this.getFileGql.watch(variables, options);
	}

	onFileUpdate(
		variables: onFileUpdateSubscriptionVariables,
		options?: SubscriptionOptionsAlone<onFileUpdateSubscriptionVariables>,
	) {
		return this.onFileUpdateGql.subscribe(variables, options);
	}

	onPreflightProgress(
		variables: onPreflightProgressSubscriptionVariables,
		options?: SubscriptionOptionsAlone<onPreflightProgressSubscriptionVariables>,
	) {
		return this.onPreflightProgressGql.subscribe(variables, options);
	}

	uploadFile(
		variables: uploadFileMutationVariables,
		options?: MutationOptionsAlone<uploadFileMutation, uploadFileMutationVariables>,
	) {
		return this.uploadFileGql.mutate(variables, options);
	}

	retryPreflight(
		variables: retryPreflightMutationVariables,
		options?: MutationOptionsAlone<retryPreflightMutation, retryPreflightMutationVariables>,
	) {
		return this.retryPreflightGql.mutate(variables, options);
	}
}
